export const HEADER_HEIGHT = '50px';
export const HEADER_HEIGHT_DESKTOP = '75px';
